import React from 'react';
import ProductDocPage from '../../../components/ProductDocPage';

const breadcrumbItems = [
  { path: '/', label: 'Home' },
  { path: '/products', label: 'Products' },
  { path: '/products/photo-kiosk-backend', label: 'Photo Kiosk Backend' },
  { path: '/products/photo-kiosk-backend/api-reference', label: 'API Reference' },
];

const sectionHeader = {
  subtitle: 'Go Live With Your Photo Kiosk in Minutes',
  title: 'Photo Kiosk Backend',
  description: (
    <>
      The only backend engine your photo kiosk might need: media upload,
      <br />
      QR code generation, branded download page
    </>
  ),
};

export default function APIReference() {
  return (
    <ProductDocPage
      breadcrumbItems={breadcrumbItems}
      markdownPath={'/content/photo-kiosk-backend/API.md'}
      pageTitle={'API Reference - Photo Kiosk Backend'}
      sectionHeader={sectionHeader}
      contentTitle={'API Reference'}
    />
  );
}
